export default function Logo() {
  return (
    <div className="web-logo">
      <img src="https://glocify.com/images/glocifysvg.svg" alt="glocify logo" />
    </div>
  );
}
